<template>
    <span :class="{ 'has-error' : $v.value.$error }">
        <span class="form__label">
            <label :for="name" class="form__label-title">{{label}}</label>
            <input class="form__input" :class="{ 'async' : !this.loginIsGenerated }"
                   :id="name"
                   :name="name"
                   :type="type"
                   :validators="validators"
                   :readonly="true"
                   v-model.trim="$v.value.$model" />
          <label v-if="minLengthValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'minLength').localizedErrorMessage) }}</label>
          <label v-if="maxLengthValidation" class="form__label-title error">{{ translate(findValidator(this.validators, 'maxLength').localizedErrorMessage) }}</label>
        </span>
    </span>
</template>
<script>
import fetch from 'cross-fetch';
import OnboardInputMixin from '@/mixins/OnboardInputMixin';

export default {
  name: 'OnboardLoginNameInput',
  mixins: [OnboardInputMixin],
  props: {
    fields: {
      type: Array,
    },
  },
  mounted() {
    this.generateLoginName();
  },
  data() {
    return {
      loginIsGenerated: false,

    };
  },
  methods: {
    generateLoginName() {
      const self = this;
      fetch(`/api/onboarding/${this.$route.params.countryCode}/generateloginname`, {
        method: 'POST',
        body: JSON.stringify(this.$props.fields),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => {
        if (res.status >= 400) {
          throw new Error(`Unable to generate eba user. Server error code: ${res.status}. 
          Server error message: ${res.statusText}`);
        }
        return res.json();
      })
        .then((result) => {
          self.value = result.loginName;
          this.loginIsGenerated = true;
          this.containsError(this.$v.value);
        })
        .catch((err) => {
          throw new Error(`Unable to generate eba user. Error code: ${err.status}. 
          Error message: ${err.statusText}`);
        });
    },
  },
};
</script>
